import { useEffect, useMemo } from 'react'
import useAppDispatch from '../../../hooks/useAppDispatch'
import useAppSelector from '../../../hooks/useAppSelector'
import {
  getS3EntriesSelector,
  updateS3AllTeamEntries,
  updateS3Entries,
} from '../../data/dataSlice'
import { CheckinPageProps } from '../../../pages/CheckinPage'
import { createLogger } from '../../../app/logger'
import { convertToCheckinEntry } from '../hooks/useCheckinDataColumns'
import { getFilterTermSelector } from '../../filter/filterSlice'
import CheckinPageContent from './CheckinPageContent'
import useEntrySort from '../hooks/useEntrySort'
import useEntryFilter from '../hooks/useEntryFilter'
import { useEntries } from '../hooks/useEntries'
import { removeDiacritics } from '../../../utils/removeDiacritics'

// eslint-disable-next-line no-unused-vars
export const logger = createLogger({
  prefix: 'CheckinPageWrapperLogic'
})

export default function CheckinPageWrapperLogic(props: CheckinPageProps) {
  const dispatch = useAppDispatch()

  const entriesFromApi = useAppSelector(getS3EntriesSelector)
  const filterTerm = useAppSelector(getFilterTermSelector)
  const textSearch = removeDiacritics(filterTerm?.toLowerCase())
  const entryFilter = useEntryFilter(textSearch)
  const entrySort = useEntrySort(textSearch)

  const entries = useEntries(entriesFromApi)

  useEffect(() => {
    const allTeamEntriesToReturn = entries.filter(x => x.team_id !== null)
    if (JSON.stringify(entriesFromApi) !== JSON.stringify(entries)) {
      dispatch(updateS3Entries(entries))
    }

    const teamsEntriesFromApi = entriesFromApi.filter(x => x.team_id !== null) ?? []
    if (JSON.stringify(teamsEntriesFromApi) !== JSON.stringify(allTeamEntriesToReturn)) {
      dispatch(updateS3AllTeamEntries(allTeamEntriesToReturn))
    }
  }, [
    dispatch,
    entries,
    entriesFromApi,
  ])

  const mappedEntries = useMemo(() => entries?.map(convertToCheckinEntry), [entries])
  const filteredEntries = useMemo(() => mappedEntries.filter(entryFilter) || [], [mappedEntries, entryFilter])
  const data = useMemo(() => filteredEntries.sort(entrySort), [filteredEntries, entrySort])

  return <CheckinPageContent {...props} data={data} />
}
